export const keys = {
  user: ['user'] as const,
  memberships: () => [...keys.user, 'memberships'] as const,
  preferences: () => [...keys.user, 'preferences'] as const,
} as const;
